import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListDataGift = createAsyncThunk(
    "dataGift/getListDataGift",
    async ({ currentPage, pageSize, telco}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/data/packages?size=${pageSize}&page=${currentPage}`;

            if (telco) {
              apiUrl += `&telco=${telco}`;
            }

            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);

export const getListTelcoDataGift = createAsyncThunk(
    "dataGift/getListTelcoDataGift",
    async ({ currentPage, pageSize}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/data/telco?size=${pageSize}&page=${currentPage}`;
            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);